import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/wilmer/projects/wilmercantillo.com/src/components/md/index.tsx";
import { graphql } from 'gatsby';
import { Badge, Link, Text } from '@chakra-ui/layout';
import { FaExternalLinkAlt } from 'react-icons/fa';
export const ProjectQuery = graphql`
  {
    site {
      siteMetadata {
        description
        title
      }
    }
    banner: file(
      relativePath: { eq: "project/orange-delivery/images/banner.png" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  ProjectQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Orange fue un un proyecto que realice con 3 compañeros a comienzos de 2020 como
una iniciativa para innovar en el campo de la logística y cadena de suministro.
Sin embargo, debido a la pandemia no pude continuar trabajando en este ya que me
vi en la necesidad de buscar un empleo que me permitiera, a mi y a mi familia,
tener una mayor estabilidad económica. A pesar de esto durante la construcción
de este proyecto obtuve muchos conocimientos y habilidades nuevas.`}</p>
    <p>{`Personalmente me encargue tanto del diseño como de la construcción de la
aplicación. Mis compañeros se encargaron del marketing del servicio a través de
redes sociales y reclutamiento de domiciliarios.`}</p>
    <h1>{`Objetivo`}</h1>
    <p>{`El objetivo de este proyecto fue construir el landing page de la empresa y una
web app que permitiera la gestión de transporte de paqueteria, es decir, un
servicio optimizado para la última milla.`}</p>
    <p>{`La aplicación consta de una interfaz de usuario con autenticación que le permite
al usuario final y a pymes solicitar envíos, así como también un bot que recibe
la solicitud y la envía al grupo de telegram, en el cual los domiciliarios
pueden aceptar y recibir detalles de dicha solicitud. Además, la interfaz de
usuario le permite observar la ubicación en tiempo real del domiciliario, le
notifica un tiempo estimado de entrega y cuando el domiciliario llegue al
destino.`}</p>
    <h1>{`Construcción del proyecto`}</h1>
    <p>{`Durante este periodo estuve muy interesado en aprender sobre cómo mejorar la
experiencia de usuario por lo que realice un curso en línea de UX/UI en el que
aprendí sobre el proceso de diseño de una interfaz de usuario. Basado en estos
principios y luego de observar múltiples diseños para inspiración empecé
realizando los wireframes y luego fui iterando basado en la retroalimentación de
mis compañeros.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9b6e34830943348fca2777bfc53b9b89/24f41/wireframes.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "107%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD50lEQVQ4y1WUTW9bRRiFp3QDC6QWdggTNjV7VqyowN2hIH4Bqy5QF72oBVb8h6qLqkIiiUIlfgFCTa2SLBxHqRLhOJt8ubZjO7ZjO/624+vrOzxn4pjE0vHMnXnnvOf9mDGFQsEUi0VzfHxs6vW6qVQqplwum0aj4b77/b75Y3nZ5LJZU8S2Wq2aBuu101PTajaN7/vXYE7ZAN9hmOz1en+12+2XrVbrZbfb/bvb6fwzGAye34vF5OQDnP4G0RJ7C+1Wa6Hf6y2MRqNFYTwefwaMgcB0Op1fdnd37fr6ut3c3LQcthyy7U7HYvT26ZMn5m0mM3dSKtnyyYmtsF8qFu3Z2ZkNgkA2FtKYUwiZwnoYj8ftzs7OkO8xoY45OKpWKvb8/PzfH+7fN5mjowhEHUgDyM7LpdKoXquNms3mCOc+hF8C43IGPGAJ3cdrSP6kIJCa4XCYfnBB+Im+L1VqlEIcykb4ivQYU6AYwCPh9jif90l4qHAhD1BrwzBM//nihTk6PPwIJweQFVCa40x+OBjkkslkfnt7O2+t/QIYVy3gQWQJwYckFBEqA4qEjU2BmzL+fXHxhrnyi9y+PZtr3xFOJ569+PkgVAgkOECdFO7oAF1wK5/LPa3Vas9x9AynDuT/GV2h+R0VeEbIh6UYPlULOWTJaUDC7WQySS8vLSnkOVX2tFq1ioCUWNlprrMgpgIbJRJ4QIn18RaWSDiKAiUdBenX8bjJ5/ORUqHQY105HkPowDyATPm+6wj1R795qqwUoixUBVEXaA0H6devXpnDg4MICofkWz06YT9UR3SV8wuFd13I5EPwFAIHfEZHSGgBlbQYp3XtOByBbCD1OAnAhDVFMYFoMlMoVinU7QA+CE/oM1VZTthP60oR+pxyJULlDkLXh4LWIfvaEdKYgkeXq0n9Xr8fqllBMF1LUfF3OHhzHAR3KGAUgighR3EcZT2KsygO3nOEVNGgwLVNJpPxV1ZWwtXVVbu2thaIWG2D2huofTebzX6Dum8p4LyAw3ls5iGbJ20f/h9yu+3pduDNXb1EImFzuVyAZxfy1ps3er4+VU6psp22mMO0ZYR7riiwC970VvgoCnXo8uqJMJ1KGZpaVVbbTOqNho/qMWrVZmM9KKqyU6gHVFVWi2xtbfn7+/uhKq0KuicMwmQi4R4H+nCoQqlX2XO4UpRrhA+lamNjY7i3t6cbIsi7DFOoMzwIer766gIpUutg48ZrjY0X4WcpFKlC1/wSGGV0PSnCnBzwartrp2t5NY/YxWY3BXwO6a9s/IjhIw4+0qiXHHxPWMrz+8w9IvqJcWbDmcd8P2b8WEX5D3K5ce0k1lFQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Wireframes",
            "title": "Wireframes",
            "src": "/static/9b6e34830943348fca2777bfc53b9b89/c1b63/wireframes.png",
            "srcSet": ["/static/9b6e34830943348fca2777bfc53b9b89/5a46d/wireframes.png 300w", "/static/9b6e34830943348fca2777bfc53b9b89/0a47e/wireframes.png 600w", "/static/9b6e34830943348fca2777bfc53b9b89/c1b63/wireframes.png 1200w", "/static/9b6e34830943348fca2777bfc53b9b89/d61c2/wireframes.png 1800w", "/static/9b6e34830943348fca2777bfc53b9b89/97a96/wireframes.png 2400w", "/static/9b6e34830943348fca2777bfc53b9b89/24f41/wireframes.png 3947w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`El objetivo de los wireframes es construir el layout de la UI en blanco y negro,
jugar con el contraste en el contenido de manera que las secciones más
importantes resalten más. Después de estar satisfecho con el resultado de esta
sección se agregan las fuentes, los colores y las imágenes. Yo hice la mayoría
de los iconos y algunas de las ilustraciones las cuales diseñe usando adobe
illustrator. Este fue el resultado del diseño:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/9b418b34b134cb51140f0f4c99e1bba0/9e8c2/design.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "89.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEfklEQVQ4y12U248URRTGi51h4l+A4UVNjI8QE33yAeHBxBg18UGNJhrQGI1GEljDxmuikCBRwHBx4yVCQBdRgRWE5SZZdZdl2IVlr87C7GV6d6enu6en69Jdfaua4+lRVmMlX+qkuvurU/U7pwkBILfHc6it5L/jGnny6RRfgZY69+1rrWK8jByAtgdPQRsARUHb+QHedsNAL2ftmuXulldOOx+8PsJ2bL4a7e24yo7uGZ+emPzKDxqdgrnjfhBcDWQ4GEbxKKi4+9gt2H5pNpqrWfZIzXbGLMedrNet68xz7iOlR0nB2dXuiG8+gfiHPSB7voRw+CRAyIph6P0uhAcNyoAxDpwL0HFoHL0J310zGHC3BrZtQ61WBcc2NXWrq0jnoS2FoV0bK40DH0D488fpmS82Jl2/7Ib5xnxvIIJ+j3poxIGioWNbIAVd7C7D0TPTKdQdGxpOFdxMtomztZqMAhTGPn3Z+LXjWSjfuKiLl75XE8UeYDr+g7NgR8NjvWjW4/v+2VJp6lJlbu6gJZJNU7XgvGXbxxv2QrdTWzjpWLWf6nX3bkIHugrnO9qNnvUbwB4c1l4EijEJqgl9VgmI05AtIDu/vrgE5/73LpCt14GYtiBudYo0oxrpGxgilVpEiO+rAkubBktSCFVTizBRUaog1s2+loEeJ48/s54UBwfI6a5u8vaLG5aM32rfSOYWHLK/88DSGrlyZaDgMW543IcgjDQeTQnhQ6L0ZU6t/b5o9PqBPBeG0bkkjn6LQ/k53mm753n9+G6PEOIcY+zCbGXxtO007iHDc3ZBhpGB7uCjIfcDHcUJRKm+HMn6hOB/U6bMh8pEGXh1fkIDfEsphUqlAoZhIOUaJEkMWuvVWZqFqgRjtK6By1jTMNWGAIhV8zJjdJQyLBmkzDFr23IAsxpNkuSQUgpc14VqtQpRFKFhks2rWoaLPDYmbQk8CLUXKm0gmRgzpFwcblA+goZF3xfFCAsbj34YP34/juNJnAdQRYyHUP2oe0mMhjpNDR2GIMNQR4FQ0GxCqlQGJUeFk4skzYO2cnUXclmbZa2XPXPrVk7VJ3OC82w914KSZZgk2qA2Bc6YnpkaVzFSRgBoaBKtOZmenSWWZS2RvK1miiXF+olKk38p4wUXAiEMySi4zNcNLpXvByDjtJ951jakfCyQ8giC61JandA63Y5UH0OdiKOwS1LzCG7eNb9oHS/dqjzUyhAcswIzYxno9B9loy8K6uO3ezmQAbg3Z8BbqJc06C1JqiENKTRHPoM0lpCkKZ4qfoE89epHhTff3Wtt+rAT3nhnD2AMr3XszuJBxukQZtLq4yAQYM5WwVykIwDNzUgby8WE2nwZTNMEKbG7lHqekDseWE5WrOkv3PXIPLlzbZmsXFdetnJdlax4+EfKxAmP8kU0LGMBlxOVmmkan0ri5CUsETMIgluBjKazGQlXkfgTrYscvP5nftvOg/nhyZl8uWLmz/YO5sdKczn8D+Zc7ufTROYBvLw9I/N2tZmLE5aRzv9fuOmyvwBJzHZtP4uxwgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Design",
            "title": "Design",
            "src": "/static/9b418b34b134cb51140f0f4c99e1bba0/c1b63/design.png",
            "srcSet": ["/static/9b418b34b134cb51140f0f4c99e1bba0/5a46d/design.png 300w", "/static/9b418b34b134cb51140f0f4c99e1bba0/0a47e/design.png 600w", "/static/9b418b34b134cb51140f0f4c99e1bba0/c1b63/design.png 1200w", "/static/9b418b34b134cb51140f0f4c99e1bba0/d61c2/design.png 1800w", "/static/9b418b34b134cb51140f0f4c99e1bba0/97a96/design.png 2400w", "/static/9b418b34b134cb51140f0f4c99e1bba0/9e8c2/design.png 5047w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <Link target="_blank" href="https://www.figma.com/file/t8t5Ik3f0PMjvITNDDoZbs/orange-web-app?node-id=212667%3A914" mdxType="Link">
  <Badge variant="subtle" colorScheme="black" textTransform="capitalize" float="right" display="flex" alignItems="center" mdxType="Badge">
    <Text marginRight="0.4rem" mdxType="Text">Diseño</Text>
    <FaExternalLinkAlt mdxType="FaExternalLinkAlt" />
  </Badge>
    </Link>
    <p>{`A continuación me dispuse a realizar el desarrollo, usando las librerías React
Js y Redux. Al momento de realizar el diseño tambien use la documentación del
sistema de diseño `}<em parentName="p">{`material`}</em>{` de google por lo que para el desarrollo utilice la
librería material ui. Además utilice la librería react hook form para el manejo
de formularios y construir mis propios componentes para las funcionalidades del
mapa con google maps api. Para el manejo del estado de la solicitud utilice la
base de datos (mysql) y una conexión en tiempo real al backend con la librería
socket io.`}</p>
    <p>{`El backend es una típica aplicación en expressjs con la estructura MVC,
utilizando express-session y passport para el manejo de la autenticación por
sesiones. El bot en telegram cuenta con las funcionalidades de registro de
domiciliarios y cambio del estado de una solicitud, tambien posee una conexión
en tiempo real con la interfaz de usuario a través de socket.`}</p>
    <p>{`Realice el despliegue de la aplicación en una instancia EC2 de AWS, la cual
sirve la aplicación dentro de un reverse proxy y la base de datos en AWS RDS.`}</p>
    <h1>{`Conclusión`}</h1>
    <p>{`Realizar este proyecto fue una experiencia desafiante y muy enriquecedora ya que
estuve a cargo del ciclo completo de desarrollo de una aplicación web.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      